import { atom } from 'recoil'
import { Lookup } from '../types'

export const availableLanguages = atom({
  key: 'availableLanguages',
  default: [] as Lookup[],
})
